export const environment = {
    production: true,
    hmr       : false,
    api: {
        baseUrl: 'https://staging-api.me-statistics.com/',
    },
};
